export class Utils{
  formatText(text:string){
    let response = text || '';
    response = response.toLowerCase();
    response = response.charAt(0).toUpperCase() + response.slice(1);
    return response;
  }
}